import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", {
  class: "form__label",
  for: ""
}, [
  /*#__PURE__*/_createElementVNode("input", {
    type: "text",
    placeholder: "Введите email",
    class: "form__input"
  })
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "form__btn button"
}, "Узнать", -1)
const _hoisted_3 = { class: "message" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "message__text" }, "Проверьте e-mail! ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.showMesage()), ["prevent"])),
    class: _normalizeClass(["form", { 'form--submitted': _ctx.isSubmitted }])
  }, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", {
        style: _normalizeStyle(`background-image: url('${_ctx.IMAGE_BASE_URL}success.svg')`),
        class: "message__image"
      }, null, 4),
      _hoisted_4
    ])
  ], 34))
}